// src/RawItemCategoryList.js ver 04 - Dec 18 2025 8:37 pm - SB118c
// src/RawItemCategoryList.js ver 03 - Nov 16 2025 9:42 pm - SB108
import React, { useState, useEffect, useRef } from 'react'; // NEW ver 02: useRef
import { Link } from 'react-router-dom';
import { useAuth } from './App';
import * as rawItemCategoryService from './api/rawItemCategoryService';
import PaginationBar2 from './PaginationBar2'; // Assuming PaginationBar is in a separate file

function RawItemCategoryList() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const auth = useAuth();

    // Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);


    // NEW ver 02: Filter State
    const [statusFilter, setStatusFilter] = useState('Active');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null); // Ref for closing dropdown on outside click


    const TENANT_ID = auth.userProfile?.SubsCoDocId;
    console.log(`TENANT_ID: ${TENANT_ID}`);

    useEffect(() => {
        const fetchCategories = async () => {
            if (!TENANT_ID) {
                setError("No associated company found. Please create one.");
                setLoading(false);
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const token = await auth.getIdToken();
                if (!token) {
                    setError("Authentication required. Please log in.");
                    setLoading(false);
                    return;
                }
                const response = await rawItemCategoryService.getRawItemCategories(TENANT_ID, token, currentPage, itemsPerPage, statusFilter); // NEW ver 02: Pass statusFilter to the service call
                setCategories(response.categories);
                setTotalItems(response.totalItems);
                setTotalPages(response.totalPages);
            } catch (err) {
                console.error("Error fetching raw item categories from Cloud Function: ", err);
                setError(`Failed to load raw item categories: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };
        fetchCategories();
    }, [auth, TENANT_ID, currentPage, itemsPerPage, statusFilter]); // NEW ver 02: Rerun if statusFilter changes

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleLimitChange = (newLimit) => {
        setItemsPerPage(newLimit);
        setCurrentPage(1); // Reset to first page when limit changes
    };


    // NEW ver 02: Dropdown handlers
    const toggleDropdown = () => {
        setIsDropdownOpen(prev => !prev);
    };

    const handleStatusFilterChange = (filter) => {
        setStatusFilter(filter);
        setCurrentPage(1); // Reset to first page on filter change
        setIsDropdownOpen(false); // Close dropdown
    };

    // NEW ver 02: Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    if (loading) return <p>Loading raw item categories...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (!TENANT_ID) return <p style={{ color: 'orange' }}>Please create a company profile to manage raw item categories.</p>;


    return (
        <div>
            <div className="page-header">
                <h2>Raw Item Categories (Tenant: ${TENANT_ID})</h2>
                {/* <Link to={`/raw-item-categories/add/${TENANT_ID}`} className="btn secondary">Add New Category</Link> */}
                <Link to={`/raw-item-categories/add`} className="btn secondary">Add New Category</Link>
            </div>

            <PaginationBar2
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />

            <table>
                <thead>
                    <tr>
                        <th>Seq ID</th> {/* NEW ver 01*/}
                        <th>Category Name</th>

                        <th className="dropdown-th" onClick={toggleDropdown} 
                        ref={dropdownRef}
                        title="Click to Filter"
                        > {/* NEW ver 03: Added title attribute NEW ver 02: Dropdown header*/}
                            Status {statusFilter !== 'no-filter' && `(${statusFilter})`}
                            {isDropdownOpen && (
                                <ul className="dropdown-menu">
                                    <li onClick={() => handleStatusFilterChange('no-filter')}>&lt;no filter&gt;</li>
                                    <li onClick={() => handleStatusFilterChange('Active')}>Active</li>
                                    <li onClick={() => handleStatusFilterChange('Not-Active')}>Not-Active</li>
                                </ul>
                            )}
                        </th>

                       <th>Comments</th> {/* NEW ver 01*/}
                        <th>Date Added</th>
                        <th>Date Last Modified</th>
                    </tr>
                </thead>
                <tbody>
                    {categories.map(category => (
                        <tr key={category.id}>
                            <td>{category.SeqId}</td> {/* NEW ver 01*/}
                            <td>
                                <Link to={`/raw-item-categories/edit/${category.id}`}>
                                    {category.RawItemCategoryName}
                                </Link>
                            </td>
                            <td>{category.Status}</td> {/* NEW ver 01*/}
                            <td>{category.Comments}</td> {/* NEW ver 01*/}
                            <td>{category.DateAdded ? new Date(category.DateAdded._seconds * 1000).toLocaleString() : 'N/A'}</td>
                            <td>{category.DateLastModified ? new Date(category.DateLastModified._seconds * 1000).toLocaleString() : 'N/A'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <PaginationBar2
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />
        </div>
    );
}

export default RawItemCategoryList;